namespace SP {
    export interface ProductionOrderInfo {
        order: OrderInfo;
        item: ItemInfo;
        toteName: string;
    }
}